import React from "react";
import { Col, Form, Input, InputNumber, Switch } from "antd";
import Select from "@components/ResponsiveSelect";
import DatePicker from "@components/ResponsiveDatePicker";
import { getSpecFieldsFromSchema } from "@/utils/equipment-category-spec-schema";

const renderControl = (field, readOnly) => {
  const disabled = readOnly;
  switch (field.type) {
    case "number":
      return <InputNumber disabled={disabled} style={{ width: "100%" }} />;
    case "select":
      return (
        <Select
          disabled={disabled}
          allowClear
          options={field.options.map((option) => ({ label: option, value: option }))}
        />
      );
    case "boolean":
      return <Switch disabled={disabled} />;
    case "textarea":
      return <Input.TextArea disabled={disabled} rows={2} />;
    case "date":
      return <DatePicker disabled={disabled} style={{ width: "100%" }} format="YYYY-MM-DD" />;
    case "label":
      return <span>{field.description || ""}</span>;
    case "text":
    default:
      return <Input disabled={disabled} />;
  }
};

const EquipmentSpecFields = ({
  schema,
  readOnly = false,
  previewOnly = false,
  namePrefix = "spec_values",
}) => {
  const fields = getSpecFieldsFromSchema(schema);
  if (!fields.length) return null;

  return (
    <>
      <Col xs={24} lg={24} />
      {fields.map((field) => (
        <Col xs={24} lg={12} key={field.id}>
          <Form.Item
            label={field.label}
            name={previewOnly ? undefined : [namePrefix, field.id]}
            valuePropName={!previewOnly && field.type === "boolean" ? "checked" : "value"}
            rules={!previewOnly && field.required ? [{ required: true, message: "This field is required" }] : []}
            extra={field.description || undefined}
          >
            {renderControl(field, readOnly || previewOnly)}
          </Form.Item>
        </Col>
      ))}
    </>
  );
};

export default EquipmentSpecFields;
